import { render } from "./ShowPointFocal.vue?vue&type=template&id=a455173c"
import script from "./ShowPointFocal.vue?vue&type=script&lang=js"
export * from "./ShowPointFocal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__